<template>
  <div class="fill-height">

    <v-toolbar
      color="primary"
      dark
      fixed
      app
      clipped-right
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" :class="{ 'pulse-white': updateExists }"></v-toolbar-side-icon>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="toolbar-action"></slot>
    </v-toolbar>

    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
      class="navdrawer"
    >
      <v-toolbar flat>
        <v-list class="ml-0 pa-0">
          <v-list-tile two-line >
            <v-list-tile-content>
              <v-list-tile-title class="body-2">{{ user.name }}</v-list-tile-title>
              <v-list-tile-sub-title class="caption" >{{ user.email }}</v-list-tile-sub-title>
              <v-list-tile-sub-title class="caption" >{{ building }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-btn icon :class="{ 'pulse-orange': updateExists }" :loading="false" v-if="updateExists" @click="showUpdateDialog">
          <v-icon>update</v-icon>
        </v-btn>

      </v-toolbar>
      <v-divider/>
      <v-list class="menu-list">
        <v-list-tile
          v-for="item in menuItems"
          :key="item.permission"
          :to="item.path"
        >
          <v-list-tile-action>
            <v-icon >{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider/>
      <v-list>
        <v-list-tile @click="exitApp">
          <v-list-tile-action>
            <v-icon >exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Sair
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

    </v-navigation-drawer>

    <UpdateDialog
      @hide="hideUpdateDialog"
      @confirm="confirmUpdateDialog"
      :visibility="updateDialogVisibility"
    />

    <slot></slot>
  </div>
</template>

<script>

import menuFunctionalities from '@/helpers/menuFunctionalities'
import { user } from '@/services/'
import { mapActions, mapState } from 'vuex'
import * as swUpdateHandler from '@/services/swUpdateHandler'
import UpdateDialog from '@/components/UpdateDialog'

export default {

  components: {
    UpdateDialog
  },

  props: {
    title: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    drawer: false,
    updateDialogVisibility: false
  }),

  computed: {
    ...mapState({
      updateExists: state => (state.swUpdate.updateExists)
    }),

    menuItems () {
      return menuFunctionalities.filter(menuFunctionality =>
        this.user.functionalities.find((functionality) => {
          return functionality === menuFunctionality.permission
        })
      )
    },

    user () {
      return user.getUserData()
    },

    building () {
      return user.getSelectedBuilding().text
    }
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout'
    }),

    exitApp () {
      this.logout()
      this.$router.push('/login')
    },

    pushRoute (path) {
      this.$router.push(path)
    },

    confirmUpdateDialog () {
      this.hideUpdateDialog()
      swUpdateHandler.postHandler()
    },

    showUpdateDialog () {
      this.updateDialogVisibility = true
    },

    hideUpdateDialog () {
      this.updateDialogVisibility = false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .navdrawer
    display flex
    flex-direction column
  .menu-list
    overflow hidden
    flex 1
</style>
